import { PropsWithChildren, ReactElement, CSSProperties } from 'react';
import { BadgeStatus, statusColorMap } from '../badge-dot/BadgeDot';
import classNames from 'classnames';
import styles from './InteractiveStatusCard.module.scss';
import { StatusCardProps } from '../status-card/StatusCard';

// Override some of the status card colors
const interactiveStatusCardColors: Partial<Record<BadgeStatus, string>> = {
  ...statusColorMap,
  Healthy: 'var(--color-border-healthy)',
  Information: 'var(--color-border-brand)',
};

export interface InteractiveStatusCardProps extends StatusCardProps {
  isUnavailable?: boolean; // Use this for states outside of the expected statuses.
  onClick?: () => void;
}

export const InteractiveStatusCard = ({
  onClick,
  status,
  colorMap,
  width,
  isUnavailable = false,
  children,
}: PropsWithChildren<InteractiveStatusCardProps>): ReactElement => {
  const statusColor = colorMap?.[status] ?? interactiveStatusCardColors[status];

  return (
    <div
      className={classNames(styles.card, {
        [styles['card--neutral']]: status === BadgeStatus.Neutral,
        [styles['card--unavailable']]: isUnavailable,
      })}
      style={{ '--dm-status-color': statusColor, '--dm-status-card-width': width } as CSSProperties}
      onClick={onClick}
      tabIndex={0}
      role="button"
    >
      {children}
    </div>
  );
};
